import React from 'react';
import { AdminReportingContainer } from '@/components/Organization/Locations/Admin/AdminReportingContainer';
import { PageTitle } from '@/components/common/PageTitle/PageTitle';
import { RouteContentWrapper } from '../../styles';

export const AdminReportingRoute = () => {
    return (
        <RouteContentWrapper>
            <PageTitle title="Reporting" />
            <AdminReportingContainer organizationId={null} />
        </RouteContentWrapper>
    );
};
